export const assetName = {
  longHeadline: 'LongHeadline',
  description: 'Description',
  shortHeadline: 'ShortHeadline',
  callToAction: 'CTA',
  background: 'Background',
} as const;

export const defaultTextFormattingOptions = {
  font: '',
  weight: '',
  color: '',
} as const;
